import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/buttons/app-store-button.png'
import _imports_1 from '@/assets/icons/buttons/google-play-button.png'
import _imports_2 from '@/assets/icons/logo/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-78224c54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello" }
const _hoisted_2 = { class: "text-block" }
const _hoisted_3 = { class: "headline" }
const _hoisted_4 = { class: "taglines" }
const _hoisted_5 = { class: "tagline" }
const _hoisted_6 = { class: "emphasis" }
const _hoisted_7 = { class: "emphasis" }
const _hoisted_8 = { class: "tagline" }
const _hoisted_9 = { class: "emphasis" }
const _hoisted_10 = { class: "emphasis" }
const _hoisted_11 = { class: "tagline" }
const _hoisted_12 = { class: "emphasis" }
const _hoisted_13 = { class: "emphasis" }
const _hoisted_14 = { class: "tagline-desc" }
const _hoisted_15 = { class: "stores" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "app-logo"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "app-logo"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "signal-card",
  "aria-label": "AI Workout Log app icon"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<span class=\"signal-orbit orbit-one\" aria-hidden=\"true\" data-v-78224c54></span><span class=\"signal-orbit orbit-two\" aria-hidden=\"true\" data-v-78224c54></span><span class=\"signal-orbit orbit-three\" aria-hidden=\"true\" data-v-78224c54></span><span class=\"signal-glow\" aria-hidden=\"true\" data-v-78224c54></span><div class=\"signal-center\" data-v-78224c54><img src=\"" + _imports_2 + "\" alt=\"\" data-v-78224c54></div>", 5)
const _hoisted_28 = {
  class: "signal-label label-one",
  href: "#weight",
  dir: "auto"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "signal-label-arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_30 = {
  class: "signal-label label-two",
  href: "#meal-input",
  dir: "auto"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "signal-label-arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_32 = {
  class: "signal-label label-three",
  href: "#about",
  dir: "auto"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "signal-label-arrow",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slideshow = _resolveComponent("Slideshow")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_Slideshow),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line1.before')), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('main.tagline.line1.highlight')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line1.middle')), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('main.tagline.line1.highlight2')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line1.after')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line2.before')), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('main.tagline.line2.highlight')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line2.middle')), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('main.tagline.line2.highlight2')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line2.after')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line3.before')), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('main.tagline.line3.highlight')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line3.middle')), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('main.tagline.line3.highlight2')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.tagline.line3.after')), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('main.tagline.desc')), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("a", {
            href: _ctx.getAppStoreLink,
            target: "_blank",
            rel: "noopener noreferrer"
          }, _hoisted_18, 8, _hoisted_16),
          _createElementVNode("a", {
            href: _ctx.getGoogleplayLink,
            target: "_blank",
            rel: "noopener noreferrer"
          }, _hoisted_21, 8, _hoisted_19)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("a", _hoisted_28, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.signalLabels.nextWorkoutGuidance')), 1),
          _hoisted_29
        ]),
        _createElementVNode("a", _hoisted_30, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.signalLabels.aiMealEvaluation')), 1),
          _hoisted_31
        ]),
        _createElementVNode("a", _hoisted_32, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.signalLabels.aiPersonalizedRoutines')), 1),
          _hoisted_33
        ])
      ])
    ])
  ]))
}